import React from "react";

export interface ColumnDef<T> {
    fieldName: keyof T;
    label: string;
    align?: "left" | "center" | "right";
    width?: number;
    sortable: boolean;
    generateLink?: (row: T) => string | undefined;
    formatCellText?: (params: {cellValue: any; row: T}) => string | CellContent;
    cellContentNode?: (params: {cellValue: any; row: T}) => React.ReactNode;
    headerInfo?: string;
    sticky?: boolean;
}

export interface CellContent {
    title?: string;
    node: React.ReactNode;
}

export enum FilterType {
    TEXT,
    ENUM,
    DATE,
    DATE_TIME,
    BOOLEAN,
    NUMBER,
    MULTI_CHOICE_ENUM,
}

export interface FilterEnumValue {
    value: string | number;
    labelKey: string;
}

export interface FilterDef<T> {
    fieldName: "anywhere" | keyof T;
    label?: string;
    filterOperators: FilterOperator[];
    type?: FilterType;
    enumValues?: FilterEnumValue[];
}

export enum FilterOperator {
    EQ = "eq",
    NOT = "not",
    LT = "lt",
    GT = "gt",
    LTE = "lte",
    GTE = "gte",
    CONTAINS = "contains",
    STARTSWITH = "startsWith",
    IN = "in",
    EX = "ex",
    NEX = "nex",
}

export type Order = "asc" | "desc";

export type FilterValue = string | number | Array<string | number>;

export interface Filter {
    f: string;
    o: FilterOperator;
    v: FilterValue;
}

export interface TypedFilter<T> {
    f: keyof T;
    o: FilterOperator;
    v: FilterValue;
}
